import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-organization-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M0.833374 18.3335H19.1667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M16.4835 18.3417V14.625"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M16.4997 9.07471C15.4831 9.07471 14.6664 9.89138 14.6664 10.9081V12.7997C14.6664 13.8163 15.4831 14.633 16.4997 14.633C17.5164 14.633 18.3331 13.8163 18.3331 12.7997V10.9081C18.3331 9.89138 17.5164 9.07471 16.4997 9.07471Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M1.74963 18.3333V5.02498C1.74963 3.34998 2.58301 2.5083 4.24134 2.5083H9.43299C11.0913 2.5083 11.9163 3.34998 11.9163 5.02498V18.3333"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M4.83337 6.875H8.95838"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M4.83337 10H8.95838"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M6.875 18.3335V15.2085"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
    </svg>
  `,
})
export class OrganizationIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
